import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { StationSelectionComponent } from './component/station-selection/station-selection.component';
import { ListModule } from '@sdbn/tmc-legacy';

@NgModule({
  declarations: [
    StationSelectionComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    ListModule
  ],
  exports: [
    StationSelectionComponent
  ]

})
export class StationSelectionModule { }
